// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"9396a52d","125":"9b7430c5","988":"6ad560f7"}[chunkId] + ".chunk.js";
};